import React, { useState } from "react";
import {
  GroupedPermissions,
  PermissionDataField,
  PermissionFieldList,
  PermissionList,
} from "../types";

export default function CheckBoxes(props: {
  data: PermissionFieldList[];
  value: string;
  range: string;
  setOperation: React.Dispatch<React.SetStateAction<string>>;

  selected: (
    value: boolean,
    index: number,
    sign: string,
    permissionId?: number
  ) => void;
  index: number;
}) {
  const { value, setOperation, selected, index, data, range } = props;

  return (
    <>
      <input
        type="checkbox"
        className="text-center h-5 w-5"
        checked={range === "access" ? data[index].access : data[index].access}
        onChange={(e) => {
          selected(e.target.checked, index, range);
          setOperation("");
        }}
      />
    </>
  );
}
